import { log } from 'log';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';

import * as actions from '../store/actions';

export const useSportsbookDestroyOnLangChange = () => {
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const prevLang = usePrevious(lang);
    const { pathLang } = useParams();
    const prevPathLang = usePrevious(pathLang);

    useEffect(() => {
        if (prevLang && lang !== prevLang || pathLang !== prevPathLang && (pathLang || prevPathLang)) {
            try {
                window.Sportsbook?.dispose();
                dispatch(actions.setAppInitialized(false));
            } catch (error) {
                log('error', '[SPORTSBOOK | Portal] Destroying app error', error);
            }
        }
        // language dependencies must be same as in useGetInitParams
    }, [lang, prevLang, dispatch, pathLang, prevPathLang]);
};
